// Canonical construction trades — the source of truth shared by the trade
// picker, vendor rolodex, and (later) the AI punch-list sorter + vendor match.
export const TRADES = [
  "Electrical",
  "Plumbing",
  "HVAC/Mechanical",
  "Framing/Carpentry",
  "Finish Carpentry",
  "Drywall",
  "Paint",
  "Flooring – Tile",
  "Flooring – Carpet/LVP",
  "Cabinetry/Millwork",
  "Countertops",
  "Roofing",
  "Masonry",
  "Concrete/Foundation",
  "Sitework/Excavation",
  "Structural Steel",
  "Metal Handrails/Railings",
  "Waterproofing",
  "Insulation",
  "Stucco/EIFS",
  "Siding",
  "Gutters",
  "Windows/Glazing",
  "Doors/Hardware",
  "Fire Sprinkler",
  "Fire Alarm",
  "Low-Voltage/Data",
  "Elevator",
  "Landscaping",
  "Irrigation",
  "Fencing",
  "Paving/Asphalt",
  "Garage Doors",
  "Appliances",
  "Solar",
  "Pool/Spa",
  "Demolition",
  "Abatement",
  "Final Clean",
  "Punch/Touch-up",
  "Other",
];

// Canonical trade -> synonyms. Used to constrain the AI's allowed trade set and
// to fuzzy-match a bucket to a rolodex vendor whose `trade` is a synonym.
export const TRADE_ALIASES = {
  "Electrical": ["Electrical", "Electrician", "Rough Electric", "Wiring", "Panel", "Devices", "Lighting"],
  "Plumbing": ["Plumbing", "Plumber", "Rough Plumbing", "Fixtures", "Water Heater", "Drain"],
  "HVAC/Mechanical": ["HVAC", "Mechanical", "Ductwork", "RTU", "Mini-split", "AC", "Furnace"],
  "Framing/Carpentry": ["Framing", "Framer", "Rough Carpentry", "Blocking", "Carpentry"],
  "Finish Carpentry": ["Finish Carpentry", "Trim", "Baseboard", "Casing", "Crown"],
  "Drywall": ["Drywall", "Sheetrock", "Hang", "Tape", "Tape & Mud", "Mud", "Finish Drywall"],
  "Paint": ["Paint", "Painter", "Painting", "Touch Up", "Touch-up"],
  "Flooring – Tile": ["Tile", "Tile Setter", "Ceramic", "Porcelain", "Grout"],
  "Flooring – Carpet/LVP": ["Carpet", "LVP", "Vinyl", "Laminate", "Flooring", "Hardwood"],
  "Cabinetry/Millwork": ["Cabinets", "Cabinetry", "Millwork", "Casework"],
  "Countertops": ["Countertops", "Counters", "Quartz", "Granite", "Stone"],
  "Roofing": ["Roofing", "Roofer", "Shingles", "Membrane", "TPO"],
  "Masonry": ["Masonry", "Mason", "Brick", "Block", "CMU"],
  "Concrete/Foundation": ["Concrete", "Foundation", "Flatwork", "Slab", "Footings"],
  "Sitework/Excavation": ["Sitework", "Excavation", "Grading", "Earthwork", "Dirt"],
  "Structural Steel": ["Structural Steel", "Steel", "Ironworker", "Erection"],
  "Metal Handrails/Railings": ["Iron Rail", "Handrail", "Guardrail", "Balustrade", "Railing", "Railings"],
  "Waterproofing": ["Waterproofing", "Damp Proofing", "Sealant", "Caulking"],
  "Insulation": ["Insulation", "Batt", "Spray Foam", "Blown"],
  "Stucco/EIFS": ["Stucco", "EIFS", "Plaster"],
  "Siding": ["Siding", "Cladding", "Hardie", "Lap"],
  "Gutters": ["Gutters", "Downspouts", "Fascia"],
  "Windows/Glazing": ["Windows", "Glazing", "Glass", "Storefront", "Curtain Wall"],
  "Doors/Hardware": ["Doors", "Hardware", "Door", "Hinges", "Locks"],
  "Fire Sprinkler": ["Fire Sprinkler", "Sprinkler", "Fire Suppression"],
  "Fire Alarm": ["Fire Alarm", "Alarm", "Life Safety"],
  "Low-Voltage/Data": ["Low Voltage", "Low-Voltage", "Data", "Network", "Cabling", "AV", "Security"],
  "Elevator": ["Elevator", "Lift", "Vertical Transportation"],
  "Landscaping": ["Landscaping", "Landscape", "Planting", "Sod"],
  "Irrigation": ["Irrigation", "Sprinklers", "Drip"],
  "Fencing": ["Fencing", "Fence", "Gate"],
  "Paving/Asphalt": ["Paving", "Asphalt", "Striping", "Seal Coat"],
  "Garage Doors": ["Garage Doors", "Overhead Door", "Roll-up"],
  "Appliances": ["Appliances", "Appliance"],
  "Solar": ["Solar", "PV", "Photovoltaic"],
  "Pool/Spa": ["Pool", "Spa", "Pools"],
  "Demolition": ["Demolition", "Demo", "Teardown"],
  "Abatement": ["Abatement", "Asbestos", "Lead", "Remediation"],
  "Final Clean": ["Final Clean", "Cleaning", "Janitorial", "Clean"],
  "Punch/Touch-up": ["Punch", "Punch List", "Touch-up", "Callback"],
  "Other": ["Other", "Misc", "General"],
};

// Best-effort match of a free-text label to a canonical trade.
export function matchTrade(raw) {
  if (!raw) return "Other";
  const s = String(raw).toLowerCase().trim();
  for (const [canon, aliases] of Object.entries(TRADE_ALIASES)) {
    if (aliases.some((a) => a.toLowerCase() === s)) return canon;
  }
  for (const [canon, aliases] of Object.entries(TRADE_ALIASES)) {
    if (aliases.some((a) => s.includes(a.toLowerCase()) || a.toLowerCase().includes(s))) return canon;
  }
  return "Other";
}
